
var sprite = require("/data/src/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 40 40\" id=\"close-icon\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <style type=\"text/css\"> #close-icon .st0{fill:#040000;} </style> <path id=\"close-icon_XMLID_4_\" class=\"st0\" d=\"M24.4,20.2L36.5,8.1c1.2-1.2,1.2-3.2,0-4.4c-1.2-1.2-3.2-1.2-4.4,0L20,15.8L7.9,3.7\r\n\tc-1.2-1.2-3.2-1.2-4.4,0c-1.2,1.2-1.2,3.2,0,4.4l12.1,12.1L3.5,32.2c-1.2,1.2-1.2,3.2,0,4.4v0c1.2,1.2,3.2,1.2,4.4,0L20,24.6\r\n\tl12.1,12.1c1.2,1.2,3.2,1.2,4.4,0v0c1.2-1.2,1.2-3.2,0-4.4L24.4,20.2z\"/> </symbol>";
module.exports = sprite.add(image, "close-icon");


//////////////////
// WEBPACK FOOTER
// ./src/icons/close-icon.svg
// module id = 318
// module chunks = 36